import axios from 'axios'

// const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:8000'

// 请求拦截器：自动注入 token
axios.interceptors.request.use(config => {
  const token = localStorage.getItem('access_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// 响应拦截器：token 失效时统一跳转登录
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('access_token')
      localStorage.removeItem('user_uuid')
      localStorage.removeItem('user_email')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export async function login(email, password) {
  
  try {
    // const response = await axios.post(`${API_URL}/api/auth/login`, {
    const response = await axios.post('/api/auth/login', {
      email,
      password
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
    
    
    // 存储 token 和用户信息
    localStorage.setItem('access_token', response.data.access_token)
    localStorage.setItem('user_uuid', response.data.user.uuid)
    localStorage.setItem('user_email', response.data.user.email)
      
    return response.data
  } catch (error) {
    console.error('完整错误信息:', error)
    throw error.response?.data || error
  }
}

export async function register(email, password, domain) {
  try {
    const response = await axios.post('/api/auth/register', {
      email,
      password,
      domain
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('注册错误:', error);
    throw error.response?.data || error;
  }
}

export async function logout() {
  try {
    
    await axios.post('/api/auth/logout')
    // 清除所有存储的信息
    localStorage.removeItem('access_token')
    localStorage.removeItem('user_uuid')
    localStorage.removeItem('user_email')
  } catch (error) {
    console.error('登出错误:', error)
    throw error
  }
}

export async function sendResetLink(email) {
  try {
    console.log('API: 发送重置链接到:', email);
    const response = await axios.post('/api/auth/send-reset-link', {
      email,
      frontend_url: window.location.origin
    }, {
      headers: {
        'Content-Type': 'application/json'
      },
      timeout: 10000 // 10秒超时
    });
    console.log('API: 重置链接发送成功:', response.data);
    return response.data;
  } catch (error) {
    console.error('API: 发送重置链接错误:', error);
    console.error('API: 错误响应:', error.response);
    console.error('API: 错误消息:', error.message);
    if (error.code === 'ECONNABORTED') {
      throw { message: '请求超时，请检查网络连接' };
    }
    throw error.response || error;
  }
}

export async function verifyResetToken(token) {
  try {
    const response = await axios.post('/api/auth/verify-reset-token', {
      token
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('验证重置令牌错误:', error);
    throw error.response?.data || error;
  }
}

export async function resetPasswordWithToken(token, newPassword) {
  try {
    const response = await axios.post('/api/auth/reset-password', {
      token,
      new_password: newPassword
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('重置密码错误:', error);
    throw error.response?.data || error;
  }
} 